/*
 * jquery-ready.js
 * Bridges inline section code to a DEFERRED jQuery.
 *
 * includes.min.js (jQuery + OwlCarousel) is loaded with defer, so it is no longer
 * available while the parser is running. Inline section scripts therefore call
 * whenJQuery(fn) instead of $(document).ready(fn). Calls made before jQuery exists
 * are queued by the stub in theme.liquid; this file drains that queue once jQuery
 * has loaded, handing each callback to jQuery's own ready() so timing is unchanged.
 */
(function () {
  var queue = window.__jqQueue || (window.__jqQueue = []);

  function run(cb) {
    try {
      window.jQuery(function () { cb(window.jQuery); });
    } catch (e) {
      if (window.console && console.error) console.error('[whenJQuery]', e);
    }
  }

  function drain() {
    while (queue.length) run(queue.shift());
  }

  window.whenJQuery = function (cb) {
    if (typeof cb !== 'function') return;
    if (window.jQuery) { run(cb); return; }
    queue.push(cb);
  };

  if (window.jQuery) {
    drain();
    return;
  }

  // jQuery missing when this runs: poll briefly rather than fail silently.
  var tries = 0;
  var timer = setInterval(function () {
    if (window.jQuery) { clearInterval(timer); drain(); }
    else if (++tries > 100) {
      clearInterval(timer);
      if (window.console && console.error) console.error('[whenJQuery] jQuery never loaded; ' + queue.length + ' callback(s) dropped');
    }
  }, 50);
})();
